import { caninesService } from "../_services"

const state = {
  all: {
    data: {},
    loading: true,
    error: {}
  },
  current: {
    data: {},
    loading: {},
    updating: {},
    error: {}
  }
}

const actions = {
  getAll({ commit }) {
    commit("getAllRequest");
    caninesService
      .getAll()
      .then(
        canines => commit("getAllSuccess", canines),
        error => commit("getAllFailure", error)
      );
  },
  getById({ commit }, id) {
    commit("getByIdRequest");

    caninesService
      .getById(id)
      .then(
        canineData => commit("getByIdSuccess", canineData),
        error => commit("getByIdFailure", error)
      );
  },
  updateCanine({ dispatch, commit }, canineData) {
    commit("updateRequest");
    console.log(canineData);
    caninesService.update(canineData).then(
      canineData => {
        dispatch("alert/success", "Registro actualizado", { root: true }),
          commit("updateSuccess", canineData);
      },
      error => {
        dispatch(
          "alert/error",
          { text: "Se ha producido un error", data: error },
          { root: true }
        ),
          commit("updateFailure", error);
      }
    )
  }
}

const mutations = {
  /*
  ALL
   */
  getAllRequest(state) {
    state.all.loading = true
  },
  getAllSuccess(state, canines) {
    state.all.loading = false
    state.all.data = canines.data
  },
  getAllFailure(state, error) {
    state.all.loading = false
    state.all.error = error
  },
  /*
  CREATE
   */
  createRequest(state) {
    state.current.updating = true
  },
  createSuccess(state, dogs) {
    state.current.updating = false
  },
  createFailure(state, error) {
    state.current.updating = false
    state.current.error = error.data
  },
  /*
   UPDATE
   */
  updateRequest(state) {
    state.current.updating = true
  },
  updateSuccess(state) {
    state.current.updating = false
  },
  updateFailure(state, error) {
    state.current.updating = false
    state.current.error = error.data
  },
  /*
  ById
   */
  getByIdRequest(state) {
    state.current.loading = true
  },
  getByIdSuccess(state, canines) {
    state.current.loading = false
    state.current.data = canines.data
  },
  getByIdFailure(state, error) {
    state.current.loading = false
    state.current.error = error
  }
}

const getters = {
  getAllCanines: state => { return JSON.parse(JSON.stringify(state.all.data)) },
  getAllCanines2 () {
    return JSON.parse(JSON.stringify(state.all.data));
  }
}

export const canines = {
  namespaced: true,
  state,
  actions,
  mutations,
  getters
};
